var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio',{attrs:{"label":_vm.label,"value":_vm.value},on:{"input":function (v){ return this$1.$emit('input', v); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }